import React, { useState } from "react";
import {
  TextArea,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { getOneEmail } from "../../lib/sysNavigation/SysNavigation";
import { useStaticContext } from "../../context/StaticContext";
import { FiMail } from "react-icons/fi";

const Edit = () => {
  const { updateOneEmailTemplate } = useStaticContext();
  const email: any = getOneEmail();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const email_templates_id = email.email_templates_id;
  const [title, setTitle] = useState<any>(email.title);
  const [description, setDescription] = useState<any>(email.message);

  const emailRoutes = "/email";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (error: any, message: any) => {
    setError(error);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const updateOneEmailHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = { title: title, message: description };

    const { message, status } = await updateOneEmailTemplate({
      data,
      id: email_templates_id,
    });

    setLoading(false);
    if (status === 200) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={emailRoutes}
      eyebrow="Settings • Email Templates"
      title="Edit Email Template"
      subtitle="Update the subject line and body of this transactional email."
      icon={<FiMail className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneEmailHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection title="Subject" hint="Keep the subject clear and concise.">
        <InputField
          props={{
            id: "title",
            title: "Subject",
            type: "text",
            value: title ? title : "",
            onChange: (e: any) => {
              setTitle(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>

      <AddSection
        title="Body"
        hint="Use short paragraphs and avoid jargon."
      >
        <TextArea
          props={{
            id: "description",
            title: "Message",
            type: "text",
            value: description ? description : "",
            rows: 8,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
